import React, { Component } from "react";

/* Router */
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom'

/* Pages */
import { Organization } from "../pages"

class Layout extends Component {
    render = () => {
        return (
            <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
                <Routes>
                    <Route path="*" element={<div />} />
                    <Route path="/" element={<Organization />} />
                </Routes>
            </Router>
        )
    }

}

export default Layout